
    import './styles.scoped.css';
    export default {
  "dropzone": "awsui_dropzone_1fham_9mlpm_93",
  "dropzone-hovered": "awsui_dropzone-hovered_1fham_9mlpm_105"
};
  